module.exports = __webpack_public_path__ + "img/bortsova.a30b46c5.png";